import { ENUM_ClientUserType } from '@api-new/common';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ClientUserState } from '@shared/store/client-user/client-user.state';
import { selectPropertiesNumber } from '@shared/store/properties/properties.selectors';

export const selectClientUserState = createFeatureSelector<ClientUserState>('clientUser');

export const selectClientUser = createSelector(selectClientUserState, (state: ClientUserState) => state.clientUser);

export const selectClientUserId = createSelector(selectClientUser, (user): string | null => (user != null && user.id) || null);

export const selectClientUserIsLoading = createSelector(selectClientUserState, (state): boolean => (state && state.loading) || false);

export const selectClientUserDeclaredNumberOfProperties = createSelector(
  selectClientUserState,
  (state): number => state.clientUser?.declaredNumberOfProperties ?? 0,
);

export const selectClientUserRemainingPropertiesNumber = createSelector(
  selectClientUserDeclaredNumberOfProperties,
  selectPropertiesNumber,
  (declaredProperties, actualProperties): number => declaredProperties - actualProperties,
);

export const selectIsClientUserTypeLandlord = createSelector(
  selectClientUser,
  (user): boolean => user.clientUserType === ENUM_ClientUserType.CLIENT_USER_TYPE_LANDLORD,
);

export const selectClientHasPendingResidentialPropertyCompletion = createSelector(
  selectClientUser,
  (user): boolean => user?.hasPendingResidentialPropertyCompletion ?? false,
);

export const selectIsClientLandlord = createSelector(
  selectClientUserState,
  (state: ClientUserState) => state.clientUser?.clientUserType === ENUM_ClientUserType.CLIENT_USER_TYPE_LANDLORD,
);
